import React from "react";
import Slider from "@mui/material/Slider";
import PlayerBig from "./PlayerBig";
import "./PlayerSuper.css";
import {
    ArrowButton, ButtonHistory,
    ButtonPlayPause,
    ButtonQuality,
    ButtonShare,
    ButtonSpeaker,
    CustomReactPlayer,
    Extend, HistoryExtended,
    Image, NumberListener, OverlayHistory,
    OverlayPlay,
    OverlayQuality,
    OverlayShare, Skeleton,
    Timeline, updatePlayerRatio,
    WithoutLogoClassStyle
} from "../../helpers/rendererHelper";
import {getContrastingColor, isColorClose} from "../../helpers/colorHelper";

export default class PlayerSuper extends PlayerBig {

    handleToggleOverlay = overlayName => {
        const playerConfigClassList = document.getElementById(overlayName + "-overlay").classList;
        if (!playerConfigClassList.contains("show-overlay")) {
            playerConfigClassList.add("show-overlay");
        } else {
            playerConfigClassList.remove("show-overlay");
        }
    }


    render() {
        const {
            author,
            backgroundColor,
            buttonColor,
            bufferDuration,
            bufferPreviewed,
            defaultVolume,
            display,
            embedEnable,
            facebook,
            fragment,
            historyHold,
            isExtend,
            historyDisplay,
            isHistoryTimeDisplay,
            isHistoryClickable,
            isHlsBuffered,
            isDirectControl,
            light,
            listenerHold,
            logo,
            main,
            muted,
            neverPlayed,
            onChangeCommittedFlush,
            playbackRate,
            stations,
            playing,
            playlist,
            previousPlayTime,
            secondaryColor,
            stream,
            streams,
            title,
            translations,
            unavailableUrl,
            url,
            volume,
            timeline,
            timelineLoaded,
            twitter,
            twitterHashtags,
            twitterAccount,
            preview,
            error,
            numberListener,
            displayListener,
        } = this.state;

        const showPlayer = !!stream;
        const color = {backgroundColor: backgroundColor, color: secondaryColor};

        document.body.style.backgroundColor = backgroundColor;

        if (historyDisplay === 'under') {
            updatePlayerRatio(1.5785, 1);
        } else {
            updatePlayerRatio(1, 1);
        }

        return <>
            <Skeleton hidden={showPlayer}></Skeleton>

            {showPlayer &&
                <>
                    <div className='player-wrapper big-player super-player' style={color}>
                        <OverlayQuality addTitle={true} streams={streams} stream={stream} main={main}
                                        translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                        onClickClose={this.handleCloseOverlay}
                                        load={this.load}/>
                        <OverlayShare embedEnable={embedEnable} facebook={facebook} twitter={twitter}
                                      twitterHashtags={twitterHashtags} twitterAccount={twitterAccount}
                                      translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                      onClickClose={this.handleCloseOverlay}/>
                        <OverlayHistory visible={historyDisplay === 'overlay'} timeline={timeline} historyHold={historyHold}
                                        timeColor={secondaryColor} isDirectControl={isDirectControl} currentTrack={title}
                                        backgroundColor={backgroundColor} currentTime={previousPlayTime} playing={playing}
                                        buttonColor={buttonColor} preview={preview} streamFormat={stream?.format} bufferSize={bufferDuration}
                                        showTimecode={isHistoryTimeDisplay} allowTimeshift={isHistoryClickable} timelineLoaded={timelineLoaded}
                                        fragment={fragment} playlist={playlist} isHlsBuffered={isHlsBuffered}
                                        onClickClose={this.handleCloseOverlay} onClick={this.handleSeekTo} type="overlay"/>
                        <div id="player-image">
                            <ButtonHistory visible={historyDisplay === 'overlay'} color={buttonColor} onClick={this.handleOpenOverlay}/>
                            <ArrowButton isExtend={isExtend} onClick={this.handleToggleExtend}
                                         buttonColor={buttonColor}
                                         backgroundColor={backgroundColor}
                                         stations={stations}

                            />
                            <Extend onClick={this.handleChangeStation}
                                    stations={stations}
                                    streams={streams}
                                    isExtend={isExtend}
                                    buttonColor={buttonColor}
                                    backgroundColor={backgroundColor}/>
                            <OverlayPlay onClickPlay={this.handlePlay} onClickPause={this.handlePause} buttonColor={buttonColor} playing={playing}
                                         backgroundColor={backgroundColor} neverPlayed={neverPlayed}/>
                            <Image display={display} onLoad={this.onLoadImage} color={secondaryColor} buttonColor={buttonColor}
                                   neverPlayed={neverPlayed} translations={translations}/>
                            <Timeline
                                fragment={fragment}
                                playlist={playlist}
                                bufferSize={bufferDuration}
                                previousPlayTime={previousPlayTime}
                                neverPlayed={neverPlayed}
                                onChange={this.handleSeekTo}
                                streamFormat={stream.format}
                                onAirLabel={translations.onair}
                                secondaryColor={secondaryColor}
                                buttonColor={buttonColor}
                                isLoading={this?.player?.player?.isLoading}
                                isHlsBuffered={isHlsBuffered}
                                isDirectControl={isDirectControl}
                                bufferPreviewed={bufferPreviewed}
                                onChangeCommittedFlush={onChangeCommittedFlush}
                                player={this.player}
                            />
                        </div>
                        <div id="player">
                            <div className="col-left">
                                <div id="title-container" className="text-fade"><p id="title">{title}</p>
                                </div>
                                <div id="author-container" className="text-fade"><p id="author">{author}</p></div>
                                <NumberListener numberListener={numberListener} displayListener={displayListener}
                                                error={error} preview={preview} color={secondaryColor} listenerHold={listenerHold}/>
                            </div>
                            <div className={WithoutLogoClassStyle(logo, "col-right")}>
                                <div id="player-buttons" className="buttons">
                                    <ButtonPlayPause
                                        onClickPlay={this.handlePlay}
                                        onClickPause={this.handlePause}
                                        color={buttonColor}
                                        playing={playing}
                                    />
                                    <div className="volume-button-slider-container">
                                        <ButtonSpeaker
                                            onClick={this.handleToggleMuted}
                                            color={buttonColor}
                                            muted={muted}
                                        />
                                        <div id="volume-container">
                                            <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                                    style={{color: isColorClose(buttonColor, '#383838') ? getContrastingColor(buttonColor, backgroundColor) : buttonColor}}
                                                    defaultValue={defaultVolume}
                                                    id="volume" orientation="vertical"
                                                    onChange={this.handleVolumeChange}/>

                                        </div>
                                    </div>

                                    <ButtonQuality
                                        visible={streams.length > 1}
                                        color={buttonColor}
                                        onClick={this.handleToggleOverlay}
                                    />
                                    <ButtonShare
                                        visible={embedEnable || facebook || twitter}
                                        color={buttonColor}
                                        onClick={this.handleToggleOverlay}
                                    />
                                </div>
                                <a id="logo" target="_blank" href="https://infomaniak.com">
                                    <p id="powered-by">powered by</p>
                                    <p id="infomaniak">infomaniak</p>
                                </a>
                            </div>
                        </div>
                        <CustomReactPlayer
                            myRef={this.ref}
                            url={url}
                            playing={playing}
                            light={light}
                            playbackRate={playbackRate}
                            volume={volume}
                            muted={muted}
                            neverPlayed={neverPlayed}
                            playlist={playlist}
                            fragment={fragment}
                            unavailableUrl={unavailableUrl}
                            onReady={this.onPlayerReady}
                            onProgress={this.handleProgress}
                            onPlay={this.handleOnPlay}
                            setPlayerInError={this.setPlayerInError}
                            preview={preview}
                            isHlsBuffered={isHlsBuffered}
                            isDirectControl={isDirectControl}
                        />
                    </div>

                    {historyDisplay === 'under' &&
                        <HistoryExtended timeline={timeline} timeColor={secondaryColor}
                                         textColor={buttonColor} isDirectControl={isDirectControl}
                                         currentTrack={title} streamFormat={stream?.format}
                                         backgroundColor={backgroundColor} historyHold={historyHold}
                                         bufferSize={bufferDuration} historyDisplay={historyDisplay}
                                         currentTime={previousPlayTime}
                                         isHlsBuffered={isHlsBuffered} timelineLoaded={timelineLoaded}
                                         fragment={fragment} playlist={playlist}
                                         onClick={this.handleSeekTo} type="extended" preview={preview}
                                         showTimecode={isHistoryTimeDisplay}
                                         allowTimeshift={isHistoryClickable} playing={playing}/>
                    }
                </>
            }
        </>;
    }
}
